import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Tooltip,
  Pagination,
  Stack,
} from "@mui/material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { VAVE, DOWNLOADIL5FILE, GETIL5DATA } from "../../AppConstant";
import img from "../../../assets/images/switch_on_icon.png";
import loadergif from "../../../assets/images/BG-switch loader_2.gif";
import AlertDialogForm from "./il5_approval_dialog";

function IdeaList({}) {
  const [refreshApi, setRefreshApi] = useState(false);
  const [allIdeas, setAllIdeas] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [reAssignOpenDialog, setreAssignOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [createuri, setCreateuri] = useState("");
  const navigate = useNavigate();
  const currentEmpId = localStorage.getItem("empid");
  const [selectedFile, setSelectedFile] = useState(null);
  const [isloading, setIsloading] = useState(false);

  const handleDownloadExcel = async (idea) => {
    try {
      setIsloading(true);
      const gridData = createExcelGridData(idea);
      await downloadExcelWithGrid(gridData, idea);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      console.error("Error downloading Excel:", error);
      alert("Error downloading Excel file. Please try again.");
    }
  };

  const createExcelGridData = (idea) => {
    const rows = 30;
    const cols = 11;

    const gridData = Array.from({ length: rows }).map((_, r) =>
      Array.from({ length: cols }).map((_, c) => {
        return {
          r,
          c,
          value: "",
          bg: "#FFFFFF",
          font: { bold: false, size: 11 },
          alignment: { horizontal: "left", vertical: "center" },
          border: { top: false, left: false, bottom: false, right: false },
          colspan: 1,
          rowspan: 1,
          hidden: false,
          hasImage: false,
          imageUrl: "",
        };
      }),
    );

    // Apply borders to all cells
    // for (let r = 0; r < gridData.length; r++) {
    //   for (let c = 0; c < gridData[r].length; c++) {
    //     gridData[r][c].border = {
    //       top: { style: "thin", color: "#000000" },
    //       left: { style: "thin", color: "#000000" },
    //       bottom: { style: "thin", color: "#000000" },
    //       right: { style: "thin", color: "#000000" },
    //     };
    //   }
    // }

    // === ROW 1 ===
    gridData[0][1].hasImage = true;
    gridData[0][1].imageUrl = img;
    gridData[0][1].colspan = 3;
    gridData[0][1].rowspan = 2;
    gridData[0][0].rowspan = 31;

    // Hide cells covered by the first image (B1 with colspan=5, rowspan=3)
    // for (let r = 0; r < 3; r++) {
    //   for (let c = 2; c < 6; c++) {
    //     // Columns C to F (index 2 to 5)
    //     if (r === 0 && c === 1) continue; // Skip the main cell itself
    //     gridData[r][c].hidden = true;
    //   }
    // }

    // Value Engineering Projects - spans columns G to N (8 columns) - colspan=8
    gridData[0][4].value = "Finance Sign off - Form";
    gridData[0][4].font = { bold: true, size: 16, color: "#000000" };
    gridData[0][4].alignment = { horizontal: "center", vertical: "center" };
    gridData[0][4].colspan = 4;
    gridData[0][4].rowspan = 2;
    // gridData[0][6].bg = "#0E2841";

    // for (let r = 0; r < 2; r++) {
    //   for (let c = 7; c < 14; c++) {
    //     // Columns H to N (index 7 to 13)
    //     if (r === 0 && c === 6) continue; // Skip the main cell itself
    //     gridData[r][c].hidden = true;
    //     gridData[r][c].bg = "#0E2841";
    //   }
    // }

    // gridData[2][6].value = " Signed off Report (2B2)";
    // gridData[2][6].font = { bold: true, size: 14, color: "#FFFFFF" };
    // gridData[2][6].alignment = { horizontal: "center", vertical: "center" };
    // gridData[2][6].colspan = 8;
    // gridData[2][6].bg = "#808080";

    // for (let c = 7; c < 12; c++) {
    //   if (c === 6) continue;
    //   gridData[2][c].hidden = true;
    //   gridData[2][c].bg = "#808080";
    // }

    gridData[0][8].hasImage = true;
    gridData[0][8].imageUrl = img;
    gridData[0][8].colspan = 3;
    gridData[0][8].rowspan = 2;
    gridData[1][1].colspan = 10;

    gridData[2][1].value = "Idea Details";
    gridData[2][1].rowspan = 8;
    gridData[2][1].alignment = { horizontal: "center", vertical: "center" };

    gridData[2][2].value = "SWITCH ON";
    gridData[2][2].font = { bold: true, size: 20, color: "#2F75B5" };
    gridData[2][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[2][2].colspan = 5;

    gridData[2][7].value = "Date";
    gridData[2][7].alignment = { horizontal: "center", vertical: "center" };
    gridData[2][8].value = "09 Nov 2025";
    gridData[2][8].colspan = 3;

    gridData[3][2].value = "Idea No : + ${idea.idea_unique_id}";
    gridData[3][2].font = { bold: true, size: 14 };
    gridData[3][2].colspan = 3;

    gridData[3][5].value = "Aggregate";
    gridData[3][6].value = idea.idea_effective || "";
    gridData[3][6].colspan = 2;

    gridData[3][8].value = "Product";
    gridData[3][9].value = idea.idea_category || "";
    gridData[3][9].colspan = 2;

    gridData[4][2].value = "Saving Category";
    gridData[4][2].colspan = 2;
    gridData[4][2].rowspan = 4;
    gridData[4][2].alignment = { horizontal: "center", vertical: "center" };

    gridData[4][4].value =
      "Design Change/PSF/Commercial /Alternate source/ M12";
    gridData[4][4].colspan = 2;
    gridData[4][4].rowspan = 4;

    gridData[4][6].value = idea.domain || "";
    gridData[4][6].colspan = 5;
    gridData[4][6].rowspan = 4;

    gridData[8][2].value = "Project Title:  ";
    gridData[8][2].colspan = 2;
    gridData[8][2].rowspan = 2;
    gridData[8][2].alignment = { horizontal: "center", vertical: "center" };

    gridData[8][4].value = idea.proposed_idea;
    gridData[8][4].colspan = 7;
    gridData[8][4].rowspan = 2;

    gridData[10][1].value = "Implementation";
    gridData[10][1].rowspan = 4;
    gridData[10][1].alignment = { horizontal: "center", vertical: "center" };

    gridData[10][2].value = "Applicable Units";
    gridData[10][2].colspan = 2;
    gridData[10][2].rowspan = 2;
    gridData[10][2].alignment = { horizontal: "center", vertical: "center" };

    gridData[10][3].rowspan = 2;
    gridData[10][4].rowspan = 2;
    gridData[10][5].rowspan = 2;
    gridData[10][6].rowspan = 2;
    gridData[10][7].rowspan = 2;
    gridData[10][8].rowspan = 2;
    gridData[10][9].rowspan = 2;
    gridData[10][10].rowspan = 2;

    gridData[12][2].value = "Applicable Models";
    gridData[12][2].colspan = 2;
    gridData[12][2].rowspan = 2;
    gridData[12][2].alignment = { horizontal: "center", vertical: "center" };

    gridData[12][3].rowspan = 2;
    gridData[12][4].rowspan = 2;
    gridData[12][5].rowspan = 2;
    gridData[12][6].rowspan = 2;
    gridData[12][7].rowspan = 2;
    gridData[12][8].rowspan = 2;
    gridData[12][9].rowspan = 2;
    gridData[12][10].rowspan = 2;

    gridData[13][1].colspan = 10;
    gridData[14][1].value = "EDM";

    gridData[14][1].rowspan = 4;
    gridData[14][1].alignment = { horizontal: "center", vertical: "center" };

    gridData[14][2].value = "ER DIN Nos";
    gridData[14][2].colspan = 2;
    gridData[14][2].rowspan = 2;
    gridData[14][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[14][2].rowspan = 2;
    gridData[14][3].rowspan = 2;
    gridData[14][4].rowspan = 2;
    gridData[14][5].rowspan = 2;
    gridData[14][6].rowspan = 2;
    gridData[14][7].rowspan = 2;
    gridData[14][8].rowspan = 2;
    gridData[14][9].rowspan = 2;
    gridData[14][10].rowspan = 2;

    gridData[16][2].value = "Released Dates";
    gridData[16][2].colspan = 2;
    gridData[16][2].rowspan = 2;
    gridData[16][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[16][2].rowspan = 2;
    gridData[16][3].rowspan = 2;
    gridData[16][4].rowspan = 2;
    gridData[16][5].rowspan = 2;
    gridData[16][6].rowspan = 2;
    gridData[16][7].rowspan = 2;
    gridData[16][8].rowspan = 2;
    gridData[16][9].rowspan = 2;
    gridData[16][10].rowspan = 2;

    gridData[17][1].colspan = 10;
    gridData[18][1].value = "";

    gridData[18][1].rowspan = 4;
    gridData[18][1].alignment = { horizontal: "center", vertical: "center" };

    gridData[18][2].value = "Implementation / PSF/ SOB date";
    gridData[18][2].colspan = 2;
    gridData[18][2].rowspan = 2;
    gridData[18][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[18][2].rowspan = 2;
    gridData[18][3].rowspan = 2;
    gridData[18][4].rowspan = 2;
    gridData[18][5].rowspan = 2;
    gridData[18][6].rowspan = 2;
    gridData[18][7].rowspan = 2;
    gridData[18][8].rowspan = 2;
    gridData[18][9].rowspan = 2;
    gridData[18][10].rowspan = 2;

    gridData[20][2].value = "MBOM / Cut off ref(MCO)";
    gridData[20][2].colspan = 2;
    gridData[20][2].rowspan = 2;
    gridData[20][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[20][2].rowspan = 2;
    gridData[20][3].rowspan = 2;
    gridData[20][4].rowspan = 2;
    gridData[20][5].rowspan = 2;
    gridData[20][6].rowspan = 2;
    gridData[20][7].rowspan = 2;
    gridData[20][8].rowspan = 2;
    gridData[20][9].rowspan = 2;
    gridData[20][10].rowspan = 2;

    gridData[21][1].colspan = 10;
    gridData[22][1].value = "Savings";

    gridData[22][1].rowspan = 4;
    gridData[22][1].alignment = { horizontal: "center", vertical: "center" };

    gridData[22][2].value = "Cost savings (Rs. Per Vehicle)";
    gridData[22][2].colspan = 2;
    gridData[22][2].rowspan = 2;
    gridData[24][2].rowspan = 2;
    gridData[24][2].colspan = 2;
    gridData[22][2].alignment = { horizontal: "center", vertical: "center" };

    gridData[22][4].value = "Investment (Rs.)";
    gridData[22][4].colspan = 2;
    gridData[22][4].rowspan = 2;
    gridData[24][4].rowspan = 2;
    gridData[24][4].colspan = 2;
    gridData[22][4].alignment = { horizontal: "center", vertical: "center" };

    gridData[22][6].value = "FY25 Volume";
    gridData[22][6].colspan = 2;
    gridData[22][6].rowspan = 2;
    gridData[24][6].rowspan = 2;
    gridData[24][6].colspan = 2;
    gridData[22][6].alignment = { horizontal: "center", vertical: "center" };

    gridData[22][8].value = "Annualised Savings (Rs. In Lacs)";
    gridData[22][8].colspan = 3;
    gridData[22][8].rowspan = 2;
    gridData[24][8].rowspan = 2;
    gridData[24][8].colspan = 3;
    gridData[22][8].alignment = { horizontal: "center", vertical: "center" };

    gridData[26][1].value = "";
    gridData[26][1].rowspan = 2;

    gridData[26][2].value = "";
    gridData[26][2].colspan = 3;
    gridData[26][2].rowspan = 2;

    gridData[26][5].value = "";
    gridData[26][5].colspan = 3;
    gridData[26][5].rowspan = 2;

    gridData[26][8].value = "";
    gridData[26][8].colspan = 3;
    gridData[26][8].rowspan = 2;

    gridData[28][1].value = "Signoff";
    gridData[28][1].rowspan = 2;
    gridData[28][1].alignment = { horizontal: "center", vertical: "center" };

    gridData[28][2].value = "Prepared By - Prathivraj C";
    gridData[28][2].alignment = { horizontal: "center", vertical: "center" };
    gridData[28][2].colspan = 3;
    gridData[29][2].value = "Name";
    gridData[29][2].colspan = 3;

    gridData[28][5].value = "Checked By - Prathivraj C";

    gridData[28][5].alignment = { horizontal: "center", vertical: "center" };
    gridData[28][5].colspan = 3;
    gridData[29][5].value = "Name";
    gridData[29][5].colspan = 3;

    gridData[28][8].value = "Approved By - Vijayapandi Jeyapitchaikani";

    gridData[28][8].alignment = { horizontal: "center", vertical: "center" };
    gridData[28][8].colspan = 3;
    gridData[29][8].value = "Name";
    gridData[29][8].colspan = 3;

    return gridData;
  };

  const downloadExcelWithGrid = async (grid, idea) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Summary");

    worksheet.properties.defaultColWidth = 15;
    worksheet.properties.defaultRowHeight = 20;

    const columnWidths = {
      1: 8,
      2: 12,
      3: 15,
      4: 12,
      5: 12,
      6: 12,
      7: 15,
      8: 12,
      9: 12,
      10: 12,
      11: 12,
      12: 15,
      13: 12,
      14: 12,
      15: 12,
      16: 15,
      17: 12,
      18: 12,
      19: 12,
    };

    Object.keys(columnWidths).forEach((col) => {
      worksheet.getColumn(parseInt(col)).width = columnWidths[col];
    });

    // First pass: Create all cells with basic styling
    grid.forEach((row, rowIndex) => {
      const excelRow = worksheet.getRow(rowIndex + 1);
      excelRow.height = 25;

      row.forEach((cell, colIndex) => {
        if (cell.hidden) return;

        const excelCell = excelRow.getCell(colIndex + 1);
        excelCell.value = cell.value || "";

        // Apply styling
        excelCell.style = {
          font: {
            name: "Arial",
            size: cell.font?.size || 11,
            bold: cell.font?.bold || false,
            color: { argb: fontColorToHex(cell.font?.color) || "FF000000" },
            italic: cell.font?.italic || false,
          },
          fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: colorToHex(cell.bg) || "FFFFFFFF" },
          },
          alignment: {
            horizontal: cell.alignment?.horizontal || "left",
            vertical: cell.alignment?.vertical || "middle",
            wrapText: true,
          },
          border: {
            top: { style: "thin", color: { argb: "FF000000" } },
            left: { style: "thin", color: { argb: "FF000000" } },
            bottom: { style: "thin", color: { argb: "FF000000" } },
            right: { style: "thin", color: { argb: "FF000000" } },
          },
        };

        if (cell.alignment?.horizontal === "center") {
          excelCell.style.alignment.horizontal = "center";
        }
      });
    });

    // Handle images separately - pass workbook as parameter
    await addImagesToWorksheet(workbook, worksheet, grid);

    // Second pass: Handle merged cells
    const mergedCells = [];

    grid.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        if (cell.hidden) return;

        const cellAddress = `${rowIndex + 1}-${colIndex + 1}`;

        if (mergedCells.includes(cellAddress)) return;

        const hasColspan = cell.colspan > 1;
        const hasRowspan = cell.rowspan > 1;

        if (hasColspan || hasRowspan) {
          const startRow = rowIndex + 1;
          const startCol = colIndex + 1;
          const endRow = hasRowspan ? rowIndex + cell.rowspan : rowIndex + 1;
          const endCol = hasColspan ? colIndex + cell.colspan : colIndex + 1;

          for (let r = startRow; r <= endRow; r++) {
            for (let c = startCol; c <= endCol; c++) {
              mergedCells.push(`${r}-${c}`);
            }
          }

          try {
            worksheet.mergeCells(startRow, startCol, endRow, endCol);

            const mergedCell = worksheet.getCell(startRow, startCol);
            mergedCell.style.alignment = {
              horizontal: cell.alignment?.horizontal || "left",
              vertical: cell.alignment?.vertical || "middle",
              wrapText: true,
            };

            mergedCell.style.font = {
              name: "Arial",
              size: cell.font?.size || 11,
              bold: cell.font?.bold || false,
              color: { argb: fontColorToHex(cell.font?.color) || "FF000000" },
              italic: cell.font?.italic || false,
            };
          } catch (error) {
            console.warn(`Could not merge cells:`, error.message);
          }
        }
      });
    });

    // Apply Arial font to all cells
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        if (!cell.style.font) cell.style.font = {};
        cell.style.font.name = "Arial";

        if (!cell.style.alignment) cell.style.alignment = {};
        cell.style.alignment.vertical = "middle";
        cell.style.alignment.wrapText = true;
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `Idea_${idea.idea_unique_id}_IL5_Report.xlsx`);
  };

  // Updated function to accept workbook as parameter
  const addImagesToWorksheet = async (workbook, worksheet, grid) => {
    const imageCells = [];

    // Find all cells that have images
    grid.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        if (cell.hasImage && cell.imageUrl) {
          imageCells.push({
            row: rowIndex + 1,
            col: colIndex + 1,
            colspan: cell.colspan || 1,
            rowspan: cell.rowspan || 1,
            imageUrl: cell.imageUrl,
          });
        }
      });
    });

    // Process each image cell
    for (const imageCell of imageCells) {
      try {
        await addImageToCell(
          workbook,
          worksheet,
          imageCell.row,
          imageCell.col,
          imageCell.rowspan,
          imageCell.colspan,
          imageCell.imageUrl,
        );
      } catch (error) {
        console.error(
          `Error adding image at row ${imageCell.row}, col ${imageCell.col}:`,
          error,
        );
      }
    }
  };

  const addImageToCell = async (
    workbook,
    worksheet,
    startRow,
    startCol,
    rowspan,
    colspan,
    imageUrl,
  ) => {
    try {
      // Fetch the image
      const response = await fetch(imageUrl);
      const imageBuffer = await response.arrayBuffer();

      // Add image to workbook
      const imageId = workbook.addImage({
        buffer: imageBuffer,
        extension: "png", // Change to 'jpeg' if needed
      });

      // Position the image in the cell area
      worksheet.addImage(imageId, {
        tl: { col: startCol - 1, row: startRow - 1 },
        br: { col: startCol - 1 + colspan, row: startRow - 1 + rowspan },
      });
    } catch (error) {
      console.error("Error processing image:", error);
      // Fallback: add text indicating image couldn't be loaded
      const cell = worksheet.getCell(startRow, startCol);
      cell.value = cell.value || "[Image]";
    }
  };

  const colorToHex = (color) => {
    if (!color) return "FFFFFFFF";
    if (color.startsWith("#")) {
      return color.replace("#", "FF");
    }
    const colorMap = {
      "#FFFFFF": "FFFFFFFF",
      "#0E2841": "FF0E2841",
      "#C0E6F5": "FFC0E6F5",
      "#808080": "FF808080",
      "#D9E1F2": "FFD9E1F2",
      "#D9D9D9": "FFD9D9D9",
      "#747474": "FF747474",
    };
    return colorMap[color] || "FFFFFFFF";
  };

  const fontColorToHex = (color) => {
    if (!color) return "FF000000";
    if (color.startsWith("#")) {
      return color.replace("#", "FF");
    }
    const colorMap = {
      "#FFFFFF": "FFFFFFFF",
      "#000000": "FF000000",
    };
    return colorMap[color] || "FF000000";
  };
  const handleButtonClick = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(1);

    handleFilter(filter);
  };

  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };

  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "green";
      case "rejected":
        return "red";
      case "inprogress":
        return "orange";
      default:
        return "gray";
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);

  useEffect(() => {
    if (!refreshApi) return;
    fetchIdeas();
    handleFilter("start");
    setOpenDialog(false);
    setreAssignOpenDialog(false);
    setRefreshApi(false);
  }, [refreshApi]);

  const fetchIdeas = async () => {
    const currentEmpId = localStorage.getItem("empid") || "";

    try {
      const response = await axios.get(VAVE + GETIL5DATA, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response.data.data || [];
      setAllIdeas(ideas);
      if (!refreshApi) {
        handleFilter("All", ideas);
      } else {
        handleFilter("inprogress", ideas);
      }
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };
//// dev

  // const handleFilter = (filter, ideas = allIdeas) => {
  //   let filtered = ideas;

    /// preparedby
  //   if (currentEmpId === "EL_0003") {
  //     if (filter === "completed") {
  //       filtered = ideas.filter(
  //         (item) =>
  //           item.il5_document_url !== null && item.il5_document_url !== "" && item.prepared_status === "accepted"
  //       );
  //     } else if (filter === "inprogress") {
  //       filtered = ideas.filter(
  //         (item) =>
  //         item.prepared_status === "inprogress"
  //       );
  //     } else if (filter === "rejected") {
  //       filtered = ideas.filter((item) => item.prepared_status === "rejected");
  //     } else {
  //       filtered = ideas;
  //     }
  //   }

  //   // /// checkedby
  //   // else if (currentEmpId === "300381") {
  //   //   if (filter === "completed") {
  //   //     filtered = ideas.filter(
  //   //       (item) =>
  //   //         item.il5_document_url !== null &&
  //   //         item.checked_status === "accepted",
  //   //     );
  //   //   } else if (filter === "inprogress") {
  //   //     filtered = ideas.filter(
  //   //       (item) =>
  //   //         item.il5_document_url === null ||
  //   //         item.checked_status === "inprogress",
  //   //     );
  //   //   }
  //   // else if (filter === "rejected") {
  //   //   filtered = ideas.filter(
  //   //     (item) =>

  //   //       item.checked_status === "rejected",
  //   //   );
  //   // }

  //   //   else {
  //   //     filtered = ideas;
  //   //   }
  //   // }

  //   /// approved by
  //   else if (currentEmpId === "300381") {
  //     if (filter === "completed") {
  //       filtered = ideas.filter(
  //         (item) =>
  //           item.il5_document_url !== null &&
  //           item.approved_status === "accepted",
  //       );
  //     } else if (filter === "inprogress") {
  //       filtered = ideas.filter(
  //         (item) =>
  //           item.il5_document_url !== null &&
  //           item.checked_status === "accepted" &&
  //           item.approved_status === "inprogress",
  //       );
  //     } else if (filter === "rejected") {
  //       filtered = ideas.filter((item) => item.approved_status === "rejected");
  //     } else {
  //       filtered = ideas;
  //     }
  //   }

    

  //   setIdeaListByEmpId(filtered);
  // };


  /// prd

  
  const handleFilter = (filter, ideas = allIdeas) => {
    let filtered = ideas;

    /// preparedby
    if (currentEmpId === "300088") {
      if (filter === "completed") {
        filtered = ideas.filter(
          (item) =>
            item.il5_document_url !== null && item.il5_document_url !== "" && item.prepared_status === "accepted"
        );
      } else if (filter === "inprogress") {
        filtered = ideas.filter(
          (item) =>
            item.il5_document_url === null || item.il5_document_url === "",
        );
      } else if (filter === "rejected") {
        filtered = ideas.filter((item) => item.prepared_status === "rejected");
      } else {
        filtered = ideas;
      }
    }

    // /// checkedby
    // else if (currentEmpId === "300381") {
    //   if (filter === "completed") {
    //     filtered = ideas.filter(
    //       (item) =>
    //         item.il5_document_url !== null &&
    //         item.checked_status === "accepted",
    //     );
    //   } else if (filter === "inprogress") {
    //     filtered = ideas.filter(
    //       (item) =>
    //         item.il5_document_url === null ||
    //         item.checked_status === "inprogress",
    //     );
    //   }
    // else if (filter === "rejected") {
    //   filtered = ideas.filter(
    //     (item) =>

    //       item.checked_status === "rejected",
    //   );
    // }

    //   else {
    //     filtered = ideas;
    //   }
    // }

    /// approved by
    else if (currentEmpId === "300503") {
      if (filter === "completed") {
        filtered = ideas.filter(
          (item) =>
            item.il5_document_url !== null &&
            item.approved_status === "accepted",
        );
      } else if (filter === "inprogress") {
        filtered = ideas.filter(
          (item) =>
            item.il5_document_url !== null &&
            item.checked_status === "accepted" &&
            item.approved_status === "inprogress",
        );
      } else if (filter === "rejected") {
        filtered = ideas.filter((item) => item.approved_status === "rejected");
      } else {
        filtered = ideas;
      }
    }

    

    setIdeaListByEmpId(filtered);
  };
  // const filteredIdeas = ideaListByEmpId.filter((item) => {
  //   const query = searchQuery.toLowerCase();
  //   return Object.values(item).some((value) =>
  //     String(value).toLowerCase().includes(query),
  //   );
  // });


const filteredIdeas = Array.isArray(ideaListByEmpId)
  ? ideaListByEmpId.filter((item) => {
      const query = searchQuery.toLowerCase();
      return Object.values(item).some((value) =>
        String(value).toLowerCase().includes(query)
      );
    })
  : [];


  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handleCloseDialog = () => {
    setOpenDialog(false);
    // setSelectedRequest(null);
  };

  const downloadApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADIL5FILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        // Create blob and download immediately
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Idea_${request.idea_unique_id}_IL5_Report.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch((error) => {
        console.error("Download failed:", error);
        setIsloading(false);
      });
  };
  return (
    <div className="container mt-2">
      {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
        <div className="d-flex align-items-center">
          <label className="me-2">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            style={{ width: "200px" }}
          />
        </div>
        <div className="d-flex gap-2">
          <Button
            variant="contained"
            color={selectedFilter === "All" ? "success" : "primary"}
            onClick={() => handleButtonClick("All")}
          >
            All
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "inprogress" ? "success" : "primary"}
            onClick={() => handleButtonClick("inprogress")}
          >
            Pending
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "completed" ? "success" : "primary"}
            onClick={() => handleButtonClick("completed")}
          >
            Accepted
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "rejected" ? "success" : "primary"}
            onClick={() => handleButtonClick("rejected")}
          >
            Rejected
          </Button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              <th>Proposed Idea</th>
              <th>Part No</th>
              <th>Savings</th>

                {/* dev */}
              {/* {currentEmpId === "EL_0003" ? ( */}
              {/* prd */}
              {currentEmpId === "300088" ? (
              
                <th>Template</th>
              ) : (
                <th>IL5 File</th>
              )}

              {/* {selectedFilter === "inprogress" ? (
                <th>Upload Excel</th>
              ) : ( */}
              <th>Aggregate</th>
              {/* )}  */}
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            {paginatedIdeas.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No ideas found
                </td>
              </tr>
            ) : (
              paginatedIdeas.map((req, index) => (
                <tr key={req.id}>
                  <td>{req.idea_unique_id}</td>

                  {selectedFilter !== "inprogress" ? (
                    <td>
                      {" "}
                      <Tooltip title={req.proposed_idea || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea?.slice(0, 15)}
                        {req.proposed_idea?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  ) : (
                    <td
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "blue",
                      }}
                      onClick={() => {
                        setSelectedRequest(req);

                        setOpenDialog(true);
                      }}
                    >
                      <Tooltip title={req.proposed_idea || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea?.slice(0, 15)}
                        {req.proposed_idea?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  )}
                  <td>{req.partno}</td>
                  <td>
                    <Tooltip title={req.benefit || ""} arrow>
                      <span>
                        {req.benefit?.slice(0, 15)}
                        {req.benefit?.length > 15 ? "..." : ""}
                      </span>
                    </Tooltip>
                  </td>

                  {/* <td style={{ cursor: "pointer" }} onChange={uploadExcel}>
                    <UploadIcon />
                  </td> */}

                  {/* <td>
                    <button
                      onClick={() => handleDownloadExcel(req)}
                      // className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                    >
                      Download Excel
                    </button>
                  </td> */}


{/* dev */}
                   {/* {currentEmpId === "EL_0003" ? ( */}
                  {/* prd */}

                  {currentEmpId === "300088" ? (

                   
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDownloadExcel(req)}
                    >
                      <DownloadIcon />
                    </td>
                  ) : (
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => downloadApi(req)}
                    >
                      <DownloadIcon />
                    </td>
                  )}
                  <td
                    style={{
                      cursor:
                        selectedFilter === "inprogress" ? "pointer" : "default",
                    }}
                  >
                    {/* {selectedFilter === "inprogress" ? (
                      <input
                        type="file"
                        onChange={uploadExcel(req)}
                        id="excelUpload"
                      />
                    ) : ( */}
                    <Tooltip title={req.idea_effective || ""} arrow>
                      <span>
                        {req.idea_effective?.slice(0, 15)}
                        {req.idea_effective?.length > 15 ? "..." : ""}
                      </span>
                    </Tooltip>
                    {/* )}  */}
                  </td>

                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => handleViewMore(req)}
                  >
                    <FormatListBulletedIcon />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details</DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>SW Id:</strong> {selectedIdea.idea_unique_id}
                </Typography>
                <Typography variant="body1">
                  <strong>Idea Category:</strong> {selectedIdea.idea_category}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient}
                </Typography>
                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Stack alignItems="center" marginTop={1} color="white">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "black",
              borderColor: "black",
              backgroundColor: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "green",
              color: "white",
            },
          }}
        />
      </Stack>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Request Details</DialogTitle>
        <DialogContent dividers>
          <AlertDialogForm
            response={selectedRequest}
            setRefreshApi={setRefreshApi}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default IdeaList;
